const _ = require('lodash')
const Promise = require('bluebird')
const { send: ajax } = require('client/lib/request')

const RETRY_TIMEOUTS = [5000, 7000, 10000]

let isNavigationFromCallback = false
let shouldRefresh = false

function navigate(params) {
  app.trigger('navigate')
  const newUrl = window.location.href
  const oldUrl = app.router.getPreviousUrl()
  const query = _.get(params, 'query', {})

  function setup(response) {
    if (response.redirect) {
      return app.router.navigate(response.redirect)
    }
    if (!window.initialRender) {
      $('#include').html(response.html)
      const bodyClass = window.wiggin.user.loggedIn ? 'logged-in' : 'logged-out'
      document.body.className = response.pageclass + ' ' + bodyClass
      if (response.pagetitle) {
        document.title = response.pagetitle
      }
    }
    isNavigationFromCallback = false
  }

  let retryCount = 0
  function requestPath() {
    const ajaxOptions = {
      url: newUrl,
      method: 'get',
      type: 'json',
      data: _.merge({ client: 1 }, query)
    }
    ajaxOptions.timeout = RETRY_TIMEOUTS[retryCount++]
    return ajax(ajaxOptions)
    .then(response => {
      const isInitialNav = !oldUrl && !isNavigationFromCallback
      if (_.isString(response) || isInitialNav) {
        app.router.reload()
        return
      }
      setup(response)
    })
    .catch(err => {
      if (err.isTimeout && RETRY_TIMEOUTS[retryCount]) {
        return requestPath()
      }
      app.router.reload()
    })
  }

  if (window.initialRender) {
    setup({
      pageclass: window.wiggin.pageclass,
      pagetitle: document.title
    })
    return Promise.resolve()
  }
  return requestPath()
}

function callback(event) {
  event.preventDefault()
  if (event.isImmediatePropagationStopped()) {
    return
  }
  event.stopImmediatePropagation()
  isNavigationFromCallback = true
  const $this = $(this)
  const target = $this.attr('target')
  const href = $this.attr('data-navigate')
  const [path, query] = _.split(href, '?')
  app.contextQuery = query || null
  app.trigger('clicknavigate')
  if (shouldRefresh) {
    window.location.assign(href)
  } else if (target) {
    window.open(href, target)
  } else if (event.metaKey) {
    window.open(href)
  } else {
    app.router.navigate(path)
  }
}

app.on('should_reload_app', function () {
  shouldRefresh = true
})

app.on('navigationend', function () {
  app.contextQuery = null
})

module.exports = { navigate, callback }
